import { useAppContext } from "@/modules/app/providers/AppContextProvider";
import SchoolRulesView from "../views/SchoolRulesView";

export default function SchoolRules() {
  const { location, allBranches } = useAppContext();
  const contractUrl =
    allBranches.find((branch) => branch.name === "Восток")?.contractUrl ??
    allBranches.find((branch) => branch.contractUrl)?.contractUrl;

  return <SchoolRulesView location={location} contractUrl={contractUrl} />;
}
